export const AnalyticsMfeEventsType = {
  ANALYTICS_CONTEXT_TO_MFE: 'ANALYTICS_CONTEXT_TO_MFE',
  ANALYTICS_MFE_CONTEXT_READY: 'ANALYTICS_MFE_CONTEXT_READY',
} as const satisfies Record<string, string>;

export const targetOriginDefault = 'https://www.qbe.com';
